const mutations = {
  SET_SEL_USER (state, user) {
    state.selUser = user
  }
}
export default mutations
